import styled from 'styled-components';
import C from '@assets/themes/colors';

export const Root = styled.div`
  width: 100%;
  min-width: 550px; 
`

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 53px;
`